import { observer } from 'mobx-react';
import React, { Component } from 'react';
import Ecoli, { IEcoli } from 'stores/models/Ecoli';
import { IOperon } from 'stores/models/LacOperon';
import Section1 from './components/sections/Section1';
import Section2 from './components/sections/Section2';
import Section3 from './components/sections/Section3';
import LacOperon from './stores/models/LacOperon';
import { DragAndDropTypes } from './stores/models/types';

interface IProps {}

interface IState {
  o1: IOperon;
  o2: IOperon;
  ecoli: IEcoli;
  ecoliExpressable?: IEcoli;
  isExpressableEcoliBlocked: boolean;
}

class View extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    const o1 = new LacOperon('Bacterial DNA', DragAndDropTypes.BacterialDNA);
    const o2 = new LacOperon('Plasmid DNA', DragAndDropTypes.PlasmidDNA);
    this.state = {
      o1,
      o2,
      ecoli: new Ecoli('E. coli', DragAndDropTypes.Ecoli, o1, o2),
      isExpressableEcoliBlocked: false,
    };
  }

  private onEcoliChange = (ecoli?: IEcoli) => {
    this.setState({ ecoliExpressable: ecoli });
  };

  private onEcoliDragStart = () => {
    this.setState({ isExpressableEcoliBlocked: true });
  };

  private onEcoliDropSuccess = () => {
    this.setState({ isExpressableEcoliBlocked: false });
  };

  render() {
    const {
      o1,
      o2,
      ecoli,
      ecoliExpressable,
      isExpressableEcoliBlocked,
    } = this.state;

    return (
      <div className='mw-880px is-unselectable'>
        <div className='container'>
          <div className=' m-5'>
            <div className='content'>
              <h1 className='title'>
                <span className='has-text-weight-bold'>Lac Operon</span>{' '}
                <span className='has-text-weight-light'>
                  Interactive Bacterium Builder
                </span>
              </h1>
            </div>

            <Section1 operonBacterial={o1} operonPlasmid={o2} />

            <div className='is-flex'>
              <Section2
                ecoli={ecoli}
                operonBacterial={o1}
                operonPlasmid={o2}
                onEcoliChange={this.onEcoliChange}
                onEcoliDragStart={this.onEcoliDragStart}
              />

              <Section3
                model={ecoliExpressable}
                isBlocked={isExpressableEcoliBlocked}
                onEcoliDropSuccess={this.onEcoliDropSuccess}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const App = observer(View);
export default App;
